enum ArchElementGeneric {
  SPRINGER = 'Springer',
  KEYSTONE = 'Keystone',
  VOUSSOIR = 'Voussoir',
  BRICK = 'Brick',
}

export default ArchElementGeneric;
